import { useToastStore } from '@/stores/toast.store';
import { cn } from '@/lib/cn';

export function Toaster() {
  const { toasts, dismiss } = useToastStore();
  return (
    <div className="pointer-events-none fixed bottom-6 left-6 z-50 flex flex-col gap-2">
      {toasts.map((t) => (
        <button
          key={t.id}
          onClick={() => dismiss(t.id)}
          className={cn(
            'pointer-events-auto max-w-sm rounded-[10px] px-4 py-3 text-start text-sm text-white shadow-[0_15px_35px_#1d344955]',
            t.tone === 'error' ? 'bg-danger' : t.tone === 'info' ? 'bg-brand' : 'bg-[#1c344b]',
          )}
        >
          {t.message}
        </button>
      ))}
    </div>
  );
}
